import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom'
import { FinancialYearDataDDL } from "../CommonDDL/FinancialYearDataDDL";
import { MonthDataDDL } from "../CommonDDL/MonthDataDDL";
import { FinancialYearHeaderDDL } from "../CommonDDL/FinancialYearHeaderDDL";
import { MonthHeaderDDL } from "../CommonDDL/MonthHeaderDDL";
import { WardnameHeaderDDL } from "../CommonDDL/WardnameHeaderDDL";
import ChangePassword from "../../Pages/Login/ChangePassword";
import { BaseUrl } from "../../Helper/BaseUrl";
import HeaderLogo from "./HeaderLogo";
import { CommonDashboardBtn } from "../CommonDashboardBtn/CommonDashboardBtn";
import { useAuthState } from "../../Helper/Context";


export default function Header(props) {

    const { DashboardHeading, handleGetFinancialYearID, flag, DashboardName, DashType,
        setDashType, Name,
        setYearValue, setMonthValue, setMonthLabel, setYearLabel, HYear, YLable, HMonth, MLable, WLable, HWard, setWardValue, setWardLabel, ProjectTypeId, HideYearMonth, HideYearMonthDDL } = props


    const [FinancialYear, setFinancialYear] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [Month, setMonth] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",

    })

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [ChangePasswordPopUp, setChangePasswordPopUp] = useState()

    const handleChangePassword = () => {
        setChangePasswordPopUp(true)
    }

    const handleOnCloseClick = () => {
        setChangePasswordPopUp(false)
    }

    const navigate = useNavigate()

    useEffect(() => {
        handleGetFinancialYearID && handleGetFinancialYearID(FinancialYear, Month)
    }, [FinancialYear.ID, Month.ID])

    useEffect(() => {
        if (setYearValue !== undefined) {
            setYearValue(FinancialYear.ID)
        }
        if (setYearLabel !== undefined) {
            setYearLabel(FinancialYear.Label)
        }
    }, [FinancialYear.ID])

    useEffect(() => {
        // console.log(Month)
        if (setMonthValue !== undefined) {
            setMonthValue(Month.ID)
        }
        if (setMonthLabel !== undefined) {
            setMonthLabel(Month.Label)
        }
    }, [Month.ID])

    useEffect(() => {
        // console.log(WardName)
        if (setWardValue !== undefined) {
            setWardValue(WardName.ID)
        }
        if (setWardLabel !== undefined) {
            setWardLabel(WardName.Label)
        }
    }, [WardName.ID])

    const logOutClick = () => {
        navigate("/")
        sessionStorage.clear()
    }

    // $(document).ready(function () {

    //     $('#sidebarCollapse').on('click', function () {
    //       $('#sidebar').toggleClass('active');
    //     });

    //   });

    const toggle = () => {
        const sidebar = document.getElementById('SidebarToggle')
        // console.log(sidebar)
        sidebar.classList.toggle('active')
        sidebar.classList.toggle('sidebaractive')
    }

    const handleLogoClick = () => {
        navigate("/dashboard")
    }

    const userDetails = useAuthState();
    const { UserID, token, M_ProjectTypeID, RoleID } = userDetails.user
    return (
        <>
            <div className="ml-lg-0 ml-md-0 row header navbar pcoded-header navbar-expand-lg navbar-expand-md navbar-light header-dark navbar_new">

                <div className="col-lg-2 col-md-4 col-12 mt-1">
                    <div className="m-header ml-md-n3">
                        <a className="mobile-menu toggler_icon" id="mobile-collapse"
                            onClick={toggle}
                            style={{ cursor: 'pointer' }}
                        >
                            <span></span></a>
                        <HeaderLogo />
                        <a href="" className="mob-toggler">

                        </a>
                    </div>
                </div>

                <div className="col-lg-4 col-md-5 col-12 ">
                    <div className="d-flex align-items-center">
                        <h4 className="head_mob ml-md-n5" style={{ fontSize: '22px' }}>
                            {/* {DashboardName}  */}

                            NMMC DAKSHA

                            {
                                M_ProjectTypeID === '5' &&
                                <span className="ps-5" style={{ color: '#e74c3c' }}>
                                    Garden Work Maintenance
                                </span>
                            }

                        </h4>

                        {
                            RoleID == 2 &&
                            <span className=" mt-1 ps-2 fw-bold" style={{ color: "#bf0000", fontSize: "16px" }}>
                                Navi Mumbai Municipal Carporation
                            </span>
                        }
                        
                    </div>
                </div>

                <div className="col-lg-5 col-md-5 col-12 ">
                    {
                        RoleID == 2 &&
                        <>
                            {
                                (M_ProjectTypeID == '0' || M_ProjectTypeID == '5') &&

                                <div className="d-flex align-items-right">
                                    <CommonDashboardBtn
                                        DashType={DashType}
                                        setDashType={setDashType}
                                        Name={Name}
                                    />
                                </div>
                            }
                        </>
                    }
                </div>

                <div className="col-lg-1 col-md-3 col-12">
                    <div className="d-flex justify-content-end">
                        {/* {
                            HideYearMonthDDL == 'Dashboard' &&
                            <div className="d-flex col-md-10 mr-md-n5 align-items-center">
                                <FinancialYearHeaderDDL
                                    FinancialYear={FinancialYear}
                                    setFinancialYear={setFinancialYear}
                                    YLable={YLable}
                                    HYear={HYear}
                                    flag={flag}
                                />
                                <MonthHeaderDDL
                                    Month={Month}
                                    setMonth={setMonth}
                                    MLable={MLable}
                                    HMonth={HMonth}
                                    flag={flag}
                                />
                            </div>
                        } */}
                        <ul className=" navbar-nav ">
                            <li>
                                <div className="logout-container mr-md-n4">
                                    <button class=" btn" data-bs-toggle="dropdown" aria-expanded="false">
                                        <img className="avatar_size" src="../assets/img/avatar-2.png" alt="" />
                                    </button>
                                    <ul className="dropdown-menu logout-dropdown" aria-labelledby="dropdownMenuButton1">
                                        <li className="lineheight p-2"
                                            onClick={handleChangePassword}
                                        >
                                            <a class="dropdown-item text-start" href="#">
                                                <i class="fa-solid fa-lock"></i> <b>Change Password </b>
                                            </a>
                                        </li>

                                        <li className="lineheight p-2"
                                            onClick={logOutClick}
                                        >
                                            <a class="dropdown-item text-start" href="#">
                                                <i class="fa-solid fa-power-off"></i> <b> Log out</b>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            {/* <div className="pb-1 header" >
                <header className="navbar pcoded-header navbar-expand-lg navbar-expand-md navbar-light header-dark navbar_new">
                    <div className="m-header">
                        <a className="mobile-menu toggler_icon" id="mobile-collapse"
                            onClick={toggle}
                            style={{ cursor: 'pointer' }}
                        >
                            <span></span></a>
                        <HeaderLogo />
                        <a href="" className="mob-toggler">
                            
                        </a>
                    </div>
                    <div className="navbar-collapse py-2">
                       
                                <div className="d-flex align-items-center">
                                    <h3 className="head_md head_mob" >{DashboardName} Maintenance</h3>
                                </div>
                        
                        <div className="d-flex mob_ddl_avtar mob_ddl_avtar1024">
                        {
                            HideYearMonthDDL == 'Dashboard' &&
                            <div className="d-flex ">
                                <FinancialYearHeaderDDL
                                    FinancialYear={FinancialYear}
                                    setFinancialYear={setFinancialYear}
                                    YLable={YLable}
                                    HYear={HYear}
                                    flag={flag}
                                />
                                <MonthHeaderDDL
                                    Month={Month}
                                    setMonth={setMonth}
                                    MLable={MLable}
                                    HMonth={HMonth}
                                    flag={flag}
                                />
                            </div>
                        }
                        <ul className="col-1 navbar-nav mr-3">
                            <li>
                                <div className="logout-container ">
                                    <button class=" btn" data-bs-toggle="dropdown" aria-expanded="false">
                                        <img className="avatar_size" src="../assets/img/avatar-2.png" alt="" />
                                    </button>
                                    <ul className="dropdown-menu logout-dropdown" aria-labelledby="dropdownMenuButton1">
                                        <li className="lineheight p-2"
                                            onClick={handleChangePassword}
                                        >
                                            <a class="dropdown-item text-start" href="#">
                                                <i class="fa-solid fa-lock"></i> <b>Change Password </b>
                                            </a>
                                        </li>

                                        <li className="lineheight p-2"
                                            onClick={logOutClick}
                                        >
                                            <a class="dropdown-item text-start" href="#">
                                                <i class="fa-solid fa-power-off"></i> <b> Log out</b>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        </ul>
                        </div>
                    </div>
                </header>
            </div> */}
            {
                ChangePasswordPopUp ?
                    <ChangePassword
                        open={ChangePasswordPopUp}
                        popupHeading="Change Password"
                        // handleIsPost={handleIsPost}
                        handleOnCloseClick={handleOnCloseClick}

                    // IsPost={IsPost}
                    />
                    : <></>
            }
        </>
    )
}